const DAILY_REPORT_ACTIONS = {
  // daily report list
  DAILY_REPORT_LIST: "DAILY_REPORT_LIST",
  DAILY_REPORT_LIST_SUCCESS: "DAILY_REPORT_LIST_SUCCESS",
  DAILY_REPORT_LIST_FAIL: "DAILY_REPORT_LIST_FAIL",
  // daily report bt user
  DAILY_REPORT_SETTING_BY_USER: "DAILY_REPORT_SETTING_BY_USER",
  DAILY_REPORT_SETTING_BY_USER_SUCCESS: "DAILY_REPORT_SETTING_BY_USER_SUCCESS",
  DAILY_REPORT_SETTING_BY_USER_FAIL: "DAILY_REPORT_SETTING_BY_USER_FAIL",
  // create daily report
  CREATE_DAILY_REPORT: "CREATE_DAILY_REPORT",
  CREATE_DAILY_REPORT_SUCCESS: "CREATE_DAILY_REPORT_SUCCESS",
  CREATE_DAILY_REPORT_FAIL: "CREATE_DAILY_REPORT_FAIL",
  // get daily report template
  DAILY_REPORT_TEMPLATE: "DAILY_REPORT_TEMPLATE",
  DAILY_REPORT_TEMPLATE_SUCCESS: "DAILY_REPORT_TEMPLATE_SUCCESS",
  DAILY_REPORT_TEMPLATE_FAIL: "DAILY_REPORT_TEMPLATE_FAIL",
  // create daily report template
  CREATE_DAILY_REPORT_TEMPLATE: "CREATE_DAILY_REPORT_TEMPLATE",
  CREATE_DAILY_REPORT_TEMPLATE_SUCCESS: "CREATE_DAILY_REPORT_TEMPLATE_SUCCESS",
  CREATE_DAILY_REPORT_TEMPLATE_FAIL: "CREATE_DAILY_REPORT_TEMPLATE_FAIL",
  // create daily report template
  CREATE_DAILY_REPORT_FOR_USER: "CREATE_DAILY_REPORT_FOR_USER",
  CREATE_DAILY_REPORT_FOR_USER_SUCCESS: "CREATE_DAILY_REPORT_FOR_USER_SUCCESS",
  CREATE_DAILY_REPORT_FOR_USER_FAIL: "CREATE_DAILY_REPORT_FOR_USER_FAIL",
  // get daily report today
  GET_DAILY_REPORT_TODAY: "GET_DAILY_REPORT_TODAY",
  GET_DAILY_REPORT_TODAY_SUCCESS: "GET_DAILY_REPORT_TODAY_SUCCESS",
  GET_DAILY_REPORT_TODAY_FAIL: "GET_DAILY_REPORT_TODAY_FAIL",
  // get all daily report template
  ALL_DAILY_REPORT_LIST: "ALL_DAILY_REPORT_LIST",
  ALL_DAILY_REPORT_LIST_SUCCESS: "ALL_DAILY_REPORT_LIST_SUCCESS",
  ALL_DAILY_REPORT_LIST_FAIL: "ALL_DAILY_REPORT_LIST_FAIL",
  SHOULD_FETCH_DATA_DAILY_TEMPLATE: "SHOULD_FETCH_DATA_DAILY_TEMPLATE",
};
export default DAILY_REPORT_ACTIONS;
